import { InvokeApi } from "../../Utils/InvokeApi";
import axios from "axios";
import { BaseUrl } from "../../Config/config";
export const CreateBook = async (data) => {
  const requestObj = {
    path: `/book/create`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};

export const UpdateBook = async (bookId, data) => {
  const requestObj = {
    path: `/book/${bookId}`,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};


export const GetBooks = async (data) => {
  const { page, limit, languageId, key, value } = data;
  const params = new URLSearchParams();
  if (data !== false) {
    params.set('page', page.toString());
    params.set('limit', limit.toString());
    if (languageId) params.set('languageId', languageId);
    // Only include key and value if both are provided
    if (key && value) {
      params.set('key', key);
      params.set('value', value);
    }
  }
  let paramQuery = data !== false ? params.toString() : ""
  const requestObj = {
    path: `/book/get?${paramQuery}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const DeleteBook = async (bookId) => {
  const requestObj = {
    path: `/book/${bookId}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const PublishBook = async (bookId, status) => {
  const requestObj = {
    path: `/publish/book/${bookId}`,
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
    postData: { status },
  };
  return InvokeApi(requestObj);
};


export const UploadImage = async (file) => {
 
  try {
    if (!file || !(file instanceof File)) {
      throw new Error("Invalid file provided for upload.");
    }

    const formData = new FormData();
    formData.append('file', file);

    const res = await axios.post(`${BaseUrl}/upload-file`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });


    // const requestObj = {
    //   path: `/upload-file`,
    //   method: 'post',
    //   postData: formData,
    // };

    // return await InvokeApi(requestObj);
    return res
  } catch (error) {
    console.error("UploadImage error:", error);
    return {
      statusCode: 500,
      message: error.message || "Image upload failed",
    };
  }
};



